// extracted by css-extract-rspack-plugin
export default {"createSpaceDialog":"CreateSpaceDialog-module__createSpaceDialog__ivPJH"};